/**
 * Per-user saved contractor views — v1, localStorage.
 *
 * A "view" is just a name + the /contractors querystring that reproduces it,
 * keyed per user id so shared machines don't leak views between logins and
 * so the future server-side upgrade is a straight copy of this shape.
 */

const key = (userId) => `bondhq-saved-views:${userId}`;
const EVENT = 'bondhq:saved-views-changed';

export function getSavedViews(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(key(userId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveView(userId, name, querystring) {
  if (!userId || !name.trim()) return getSavedViews(userId);
  const views = getSavedViews(userId).filter((v) => v.name !== name.trim());
  views.push({ name: name.trim(), qs: querystring });
  views.sort((a, b) => a.name.localeCompare(b.name));
  localStorage.setItem(key(userId), JSON.stringify(views));
  window.dispatchEvent(new Event(EVENT));
  return views;
}

export function removeView(userId, name) {
  if (!userId) return [];
  const views = getSavedViews(userId).filter((v) => v.name !== name);
  localStorage.setItem(key(userId), JSON.stringify(views));
  window.dispatchEvent(new Event(EVENT));
  return views;
}

export function onSavedViewsChange(fn) {
  window.addEventListener(EVENT, fn);
  window.addEventListener('storage', fn); // cross-tab
  return () => {
    window.removeEventListener(EVENT, fn);
    window.removeEventListener('storage', fn);
  };
}
